var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { connect } from 'react-redux';
import ButtonWidget from 'nucleus-widgets/lib/Button/ButtonWidget';
import { defaultMemoize } from 'reselect/lib/index';
import { bindActionCreators } from 'redux';
import { getAssociatedRegistrationPathId } from '../../redux/selectors/shared';
import { canRegister } from '../../redux/selectors/currentRegistrant';
import { canWaitlist } from '../../redux/selectors/event';
import { promptToStartNewRegistration } from './actions';
import ClassNames from 'nucleus-widgets/lib/Button/Button.less';
import ButtonStyles from 'nucleus-widgets/lib/Button/Button.less';
import { createLinkClickHandler, isAlreadyRegisteredLinkDisabled } from './util';
export function mapStateToProps(state, props) {
    var _a = state.defaultUserSession, isPlanner = _a.isPlanner, isPreview = _a.isPreview, isArchived = state.event.isArchived;
    var buttonDisabled = (isArchived ||
        (!canRegister(state) &&
            !canWaitlist(state, getAssociatedRegistrationPathId(state, state.userSession.regTypeId)))) &&
        !isPlanner &&
        !isPreview;
    var linkDisabled = isAlreadyRegisteredLinkDisabled(state);
    var mappedProps = {
        disabled: buttonDisabled,
        kind: 'button'
    };
    if (buttonDisabled) {
        mappedProps.classes = __assign(__assign({}, ClassNames), { button: __assign(__assign({}, ButtonStyles), { disabled: ClassNames.disabled }) });
    }
    if (linkDisabled) {
        mappedProps.config = __assign(__assign({}, props.config), { link: {
                enabled: false,
                text: ''
            } });
    }
    return mappedProps;
}
export var mapDispatchToProps = function () {
    var memoizedCreateLinkClickHandler = defaultMemoize(createLinkClickHandler);
    return function (dispatch, props) {
        var registerNowText = props.config.text.htmlContent
            ? props.config.text.htmlContent.replace(/<[^>]*>/g, '')
            : props.config.text;
        var actions = {
            clickHandler: promptToStartNewRegistration,
            linkClickHandler: memoizedCreateLinkClickHandler('EventGuestSide_ExistingInvitee_AlreadyRegistered_Header__resx', registerNowText)
        };
        return bindActionCreators(actions, dispatch);
    };
};
/**
 * Data wrapper for the event register now widget.
 */
export default connect(mapStateToProps, mapDispatchToProps)(ButtonWidget);
